import axios from "axios";
import { url, auth_key, user_id } from "../../../constants";

export const getFeedback = async () => {
  try {
    const response = await axios.get(`${url}/feedback_log`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getInvitedpplLogs = async () => {
  try {
    const response = await axios.get(`${url}/invitedpeoplelog`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getInvitedppl = async () => {
  try {
    const response = await axios.get(`${url}/invitedpeople`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getLogsDetails = async (name) => {
  try {
    const response = await axios.get(`${url}/invitepersonlog/${name}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const addInvite = async (name) => {
  try {
    const response = await axios.get(`${url}/generateinvitaionkey/${name}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getReport = async () => {
  try {
    const response = await axios.get(`${url}/report`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getReportSource = async (name) => {
  try {
    const response = await axios.get(`${url}/report_source/${name}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getLogsbyTime = async (days) => {
  try {
    const response = await axios.get(
      `${url}/invitepersonlogbytime/${days} Day`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getRegisterUsers = async () => {
  try {
    const response = await axios.get(`${url}regesteruser`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSuggestionList = async () => {
  try {
    const response = await axios.get(`${url}seggestionList`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const addSuggestionList = async (suggestion) => {
  try {
    const response = await axios.get(`${url}addSeggestion?new=${suggestion}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteSuggestionList = async (suggestion) => {
  try {
    const response = await axios.get(
      `${url}deleteSeggestion?old=${suggestion}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateSuggestionList = async (old, suggestion) => {
  try {
    const response = await axios.get(
      `${url}renameSeggestion?old=${old}&new=${suggestion}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSearchEngine = async (search) => {
  try {
    const response = await axios.get(`${url}searchEngine/${search}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSource = async (ISIN) => {
  try {
    const response = await axios.get(`${url}source_link/${ISIN}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getChartTable = async (query) => {
  try {
    const response = await axios.post(
      `${url}/portfolioindextable`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      },
      {
        Query: query,
        period: "all",
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

export const getChart = async (query, source, period, ISINString) => {
  try {
    const response = await axios.post(
      `${url}/portfolioindex`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      },
      {
        Query: query,
        period: period,
        ISIN_Selected: ISINString,
      },
      {
        cancelToken: source.token,
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};
